// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Detail_wrapper__1gMGs","content":"Detail_content__1EtXn","item":"Detail_item__komvm"};